module.exports = __webpack_public_path__ + "static/media/verdegro.b6ae278f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/verdegro.webp
// module id = 571
// module chunks = 0